import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import clsx from "clsx";
import { Fragment } from "react";

function BankTransfers() {
  return (
    <div className="bg-gray-100 py-5">
      <div className="w-[96%] mx-auto max-w-[1365px] m-3 p-4 bg-white rounded-xl shadow-2xl/20 ">
        <svg
          class="np-logo-svg np-logo-svg--size-md mx-auto mt-5  "
          xmlns="http://www.w3.org/2000/svg"
          width="106"
          height="24"
          fill="none"
        >
          <path
            fill="#222222"
            d="M58.7377.358803h6.4982L61.9668 23.681h-6.4983L58.7377.358803Zm-8.1922 0L46.1602 13.794 44.2465.358803h-4.5448L33.9608 13.7541 33.2433.358803h-6.2991L29.1369 23.681h5.2226L40.818 8.93022 43.0904 23.681h5.1428L56.7249.358803h-6.1794ZM105.103 13.9136H89.6744c.0798 3.0299 1.8937 5.0233 4.5648 5.0233 2.0133 0 3.608-1.0765 4.8439-3.1296l5.2079 2.3674C102.501 21.7017 98.729 24 94.0798 24 87.741 24 83.535 19.7342 83.535 12.8771 83.535 5.34221 88.4784 0 95.4552 0c6.1398 0 10.0068 4.14618 10.0068 10.6046 0 1.0765-.12 2.1528-.359 3.309Zm-5.7807-4.46512c0-2.71095-1.515-4.42525-3.9468-4.42525-2.5117 0-4.5848 1.79402-5.143 4.42525h9.0898ZM6.63326 7.38685 0 15.1389h11.844l1.3309-3.6553H8.09965l3.10105-3.58555.01-.09511L9.19424 4.3319h9.07196l-7.0323 19.3492h4.8124L24.538.358823H2.60021L6.63326 7.38685Zm69.16744-2.3636c2.2923 0 4.301 1.23273 6.0551 3.34565l.9216-6.57488C81.1429.687707 78.9303 0 76 0c-5.8205 0-9.0896 3.40865-9.0896 7.73421 0 2.99999 1.6744 4.83389 4.4252 6.01989l1.3156.598c2.4518 1.0466 3.1097 1.5649 3.1097 2.6712 0 1.1461-1.1064 1.8737-2.7907 1.8737-2.7808.01-5.0332-1.4153-6.7276-3.8472l-.939 6.699C67.2332 23.2201 69.7067 24 72.9702 24c5.5315 0 8.9302-3.1894 8.9302-7.6147 0-3.0099-1.3355-4.9434-4.7044-6.4584l-1.4351-.67772c-1.9934-.88708-2.6711-1.37543-2.6711-2.35216 0-1.05647.9269-1.87377 2.7109-1.87377Z"
          ></path>
        </svg>
        <div
          className="text-center text-gray-500 uppercase tracking-widest leading-[100%] my-7
"
        >
          Domestic and International{" "}
        </div>
        <h1
          style={{ fontFamily: "Manrope, sans-serif" }}
          className="font-light text-center text-5xl  tracking-tight mb-12 leading-[1] md:leading-1  "
        >
          Bank Transfer Details
        </h1>

        <TabGroup>
          <TabList className="block mx-auto text-center transition-all duration-300">
            <Tab as={Fragment} className="py-1 px-6 m-3 text-[#666666] ">
              {({ hover, selected }) => (
                <button
                  className={
                    ("ring-0",
                    clsx(
                      hover &&
                        "ring-0 rounded-full bg-[#eeeeee]  cursor-pointer !text-gray-800 transition-all duration-500",
                      selected &&
                        "ring-0 rounded-full bg-[#DD0101] text-white transition-all duration-500 font-bold"
                    ))
                  }
                >
                  UK (GBP)
                </button>
              )}
            </Tab>
            <Tab as={Fragment} className="py-1 px-6 mr-3 text-[#666666]">
              {({ hover, selected }) => (
                <button
                  className={
                    ("ring-0",
                    clsx(
                      hover &&
                        "ring-0 rounded-full bg-[#eeeeee]  cursor-pointer !text-gray-800 transition-all duration-500",
                      selected &&
                        "ring-0 rounded-full bg-[#DD0101] text-white transition-all duration-500 font-bold"
                    ))
                  }
                >
                  Australia (AUD)
                </button>
              )}
            </Tab>
            <Tab as={Fragment} className="py-1 px-6 mr-3 text-[#666666]">
              {({ hover, selected }) => (
                <button
                  className={
                    ("ring-0",
                    clsx(
                      hover &&
                        "ring-0 rounded-full bg-[#eeeeee]  cursor-pointer !text-gray-800 transition-all duration-500",
                      selected &&
                        "ring-0 rounded-full bg-[#DD0101] text-white transition-all duration-500 font-bold"
                    ))
                  }
                >
                  Canada (CAD)
                </button>
              )}
            </Tab>
            <Tab as={Fragment} className="py-1 px-6 mr-3 text-[#666666]">
              {({ hover, selected }) => (
                <button
                  className={
                    ("ring-0",
                    clsx(
                      hover &&
                        "ring-0 rounded-full bg-[#eeeeee]  cursor-pointer !text-gray-800 transition-all duration-500",
                      selected &&
                        "ring-0 rounded-full bg-[#DD0101] text-white transition-all duration-500 font-bold"
                    ))
                  }
                >
                  USA (USD)
                </button>
              )}
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              {/* UK */}
              <p
                className="font-normal md:text-[21px] text-center text-[#666666] my-6 p-6"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                If you're sending money from a bank in the UK, you can use these
                details to make a domestic transfer. If you're sending from
                somewhere else, make an international Swift transfer.
              </p>
              <table class="table-auto w-full md:max-w-[70%] mx-auto my-10 text-[#666666] text-[19px] p-3">
                <tbody>
                  <tr className="border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold  py-3">Name:</td>
                    <td className="pl-3 py-3 font-mono">
                      Mfi The Awakening Network Ltd
                    </td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Account number:</td>
                    <td className="pl-3 py-3 font-mono">87980341</td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Sort code:</td>
                    <td className="pl-3 py-3 font-mono">
                      23-08-01
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from the UK
                      </em>
                    </td>
                  </tr>

                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">IBAN:</td>
                    <td className="pl-3 py-3 font-mono">
                      GB21 TRWI 2308 0187 9803 41
                    </td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Swift/BIC:</td>
                    <td className="pl-3 py-3 font-mono">
                      TRWIGB2LXXX
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from outside the UK
                      </em>
                    </td>
                  </tr>
                  <tr className="my-3">
                    <td className="font-bold py-3">Bank name and address:</td>
                    <td className="pl-3 py-3 font-mono">
                      Wise Payments Limited, 1st Floor, Worship Square, 65
                      Clifton Street, London, EC2A 4JE, United Kingdom
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel>
              {/* Australia */}
              <p
                className="font-normal md:text-[21px] text-center text-[#666666] my-6 p-6"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                If you're sending money from a bank in Australia, you can use
                these details to make a domestic transfer. If you're sending
                from somewhere else, make an international Swift transfer.
              </p>
              <table class="table-auto w-full md:max-w-[70%] mx-auto my-10 text-[#666666] text-[19px] p-3">
                <tbody>
                  <tr className="border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold  py-3">Name:</td>
                    <td className="pl-3 py-3 font-mono">
                      Mfi The Awakening Network Ltd
                    </td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Account number:</td>
                    <td className="pl-3 py-3 font-mono">229555165</td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">BSB code:</td>
                    <td className="pl-3 py-3 font-mono">
                      774001
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from Australia
                      </em>
                    </td>
                  </tr>

                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Swift/BIC:</td>
                    <td className="pl-3 py-3 font-mono">
                      TRWIAUS1XXX
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from outside Australia
                      </em>
                    </td>
                  </tr>
                  <tr className="my-3">
                    <td className="font-bold py-3">Bank name and address:</td>
                    <td className="pl-3 py-3 font-mono">
                      Wise Australia Pty Ltd, Suite 1, Level 11, 66 Goulburn
                      Street, Sydney, NSW, 2000, Australia
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel>
              {/* Canada */}
              <p
                className="font-normal md:text-[21px] text-center text-[#666666] my-6 p-6"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                If you're sending money from a bank in Canada, you can use these
                details to make a domestic transfer. If you're sending from
                somewhere else, make an international Swift transfer.
              </p>
              <table class="table-auto w-full md:max-w-[70%] mx-auto my-10 text-[#666666] text-[19px] p-3">
                <tbody>
                  <tr className="border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold  py-3">Name:</td>
                    <td className="pl-3 py-3 font-mono">
                      Mfi The Awakening Network Ltd
                    </td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Account number:</td>
                    <td className="pl-3 py-3 font-mono">200116862609</td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Institution number:</td>
                    <td className="pl-3 py-3 font-mono">
                      621
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from Canada
                      </em>
                    </td>
                  </tr>

                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Transit number:</td>
                    <td className="pl-3 py-3 font-mono">
                      16001
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from Canada
                      </em>
                    </td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Swift/BIC:</td>
                    <td className="pl-3 py-3 font-mono">
                      TRWICAW1XXX
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from outside Canada
                      </em>
                    </td>
                  </tr>
                  <tr className="my-3">
                    <td className="font-bold py-3">Bank name and address:</td>
                    <td className="pl-3 py-3 font-mono">
                      Wise Payments Canada Inc., 99 Bank Street, Suite 1420,
                      Ottawa, ON, K1P 1H4, Canada
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel>
              {/* USA */}
              <p
                className="font-normal md:text-[21px] text-center text-[#666666] my-6 p-6"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                If you're sending money from a bank in the US, you can use these
                details to make a domestic transfer. If you're sending from
                somewhere else, make an international Swift transfer.
              </p>
              <table class="table-auto w-full md:max-w-[70%] mx-auto my-10 text-[#666666] text-[19px] p-3">
                <tbody>
                  <tr className="border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold  py-3">Name:</td>
                    <td className="pl-3 py-3 font-mono">
                      Mfi The Awakening Network Ltd
                    </td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Account number:</td>
                    <td className="pl-3 py-3 font-mono">213596949316</td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Account type:</td>
                    <td className="pl-3 py-3 font-mono">
                      Checking
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from the US
                      </em>
                    </td>
                  </tr>

                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">
                      Routing number (for wire and ACH):
                    </td>
                    <td className="pl-3 py-3 font-mono">
                      101019628
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from the US
                      </em>
                    </td>
                  </tr>
                  <tr className=" border-b-1 border-dashed border-gray-300 my-3">
                    <td className="font-bold py-3">Swift/BIC:</td>
                    <td className="pl-3 py-3 font-mono">
                      TRWIUS35XXX
                      <br />
                      <em className="text-sm text-gray-400">
                        Use when sending money from outside the US
                      </em>
                    </td>
                  </tr>
                  <tr className="  my-3">
                    <td className="font-bold py-3">Bank name and address:</td>
                    <td className="pl-3 py-3 font-mono">
                      Wise US Inc, 30 W. 26TH Street, Sixth Floor, New York, NY,
                      10010, United States
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </div>
  );
}
export default BankTransfers;
